import Dialog from '@zenbusiness/zui/Dialog';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import { styled } from '@zenbusiness/zui/styles';

const DialogStyle = () => ({
  padding: 0
});

const DialogTitleStyle = () => ({
  padding: '0px 5px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 60
});

const DialogContentStyle = ({ showScroll, isInlineButton }) => ({
  overflowY: showScroll ? 'initial' : 'auto',
  padding: 0,
  paddingBottom: isInlineButton ? 0 : '50px'
});

export const DialogStyled = styled(Dialog)(DialogStyle);
export const DialogTitleStyled = styled(DialogTitle)(DialogTitleStyle);
export const DialogContentStyled = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== 'showScroll' && prop !== 'isInlineButton'
})(DialogContentStyle);
